/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function RegisteredPartiesInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Information for Registered Political Parties for Nova Scotia Provincial Elections"
              description={
                <>
                  <h4>Please note, Effective December 10, 2024, Nova Scotians United was deregistered as a political party in Nova Scotia under Section 186 of the Elections Act.</h4>
                  <br />
                  <p>Our Province&#39;s legislation defines a registered party as a group of individuals whose primary purpose is the fielding of candidates for election as members of the House of Assembly.</p>
                  <br />
                  <p>Perhaps you have some ideals you want to share with Nova Scotia and feel that forming a new registered party is the best way to do that. Choosing to become involved in the history and direction of our province is a great commitment.</p>
                  <br />
                  <p>However, before you can become a registered party, you must meet certain registration criteria established by the <em><a href="/files/ElectionsAct.pdf"><u>Elections Act</u></a></em>.</p>
                  <br />
                  <p>You&#39;ll find all the details in the <em><a href="/files/ElectionsAct.pdf"><u>Elections Act </u></a></em>&nbsp;Section 180</p>
                  <br />
                  <p>Party Registration:</p>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/PoliticalParties/Form 3 Registration of Political party.pdf"><u>Form 3 Registration of Political Party</u></a><br />
                    </li>
                  </ul>
                  <br />
                  <p>This registration is required under the <em><a href="/files/ElectionsAct.pdf"><u>Elections Act</u></a></em> should take place before an election is called. A political party registered with the Chief Electoral Officer becomes a recognized political party in Nova Scotia.</p>
                  <br />
                  <p>Annual reporting, in addition to post-election reporting is required. The forms for this reporting are 3-1 through 3-5:</p>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Form 3-1, Renewal of a Registered Political Party</li>
                    <li>Form 3-2, Registered Party Update Information</li>
                    <li>Form 3-3, Financial Reporting of a Registered Party, Statement of Income and Expenses</li>
                    <li>Form 3-3A, Financial Return for a Registered Party, Statement of Monetary Contributions and Fundraising Events</li>
                    <li>Form 3-3B, Financial Return for a Registered Party, Statement of Donations in Kind</li>
                    <li>Form 3-3C, Financial Return for a Registered Party, Statement of Transfers to and from EDAs and Candidates</li>
                    <li>Form 3-3D, Financial Return for a Registered Party, Loan or Line of Credit</li>
                    <li>Form 3-3F, Financial Return for a Registered Party, Summary of Election Expenses</li>
                    <li>Form 3-3Fa, Financial Return for a Registered Party, Detail of Election Expenses</li>
                    <li>Form 3-4, Financial Return for a Registered Party, Party Balance Sheet</li>
                    <li>Form 3-5, Report Respecting Tax Receipts for a Registered Party</li>
                  </ul>
                  <br/>
                  <p>Forms: <a href="https://www.electionsnovascotia.ca/PartiesFormsAndHandbooks">Link</a></p>
                  <br />
                  <p>The deadlines for filing these reports are:</p>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Change in information: 10 days after effective date of change</li>
                    <li>Annual Report: April 30</li>
                    <li>Election Expenses: 120 days after return of writ</li>
                    <li>Fundraising: 120 days after event
                    </li>
                  </ul>
                  <br />
                  <br />
                  <h3>
                    Registered Political Parties in Nova Scotia
                  </h3>
                  <h4>There are four registered political parties in Nova Scotia. These are:</h4>
                  <br />
                  <p><strong>Green Party of Nova Scotia</strong><br />
                    Website: <a href="http://www.greenpartyns.ca"><u>www.greenpartyns.ca</u></a></p>
                  <br />
                  <p><strong>Nova Scotia Liberal Party</strong><br />
                    Website: <a href="http://www.liberal.ns.ca"><u>www.liberal.ns.ca</u></a></p>
                  <br />
                  <p><strong>Nova Scotia New Democratic Party</strong><br />
                    Website:&nbsp;<a href="http://www.nsndp.ca/"><u>www.nsndp.ca</u></a></p>
                  <br />
                  <p><strong>Progressive Conservative Association of Nova Scotia</strong><br />
                    Website: <a href="http://www.pcpartyns.ca"><u>www.pcpartyns.ca</u></a></p>
                  <br />
                  <p><strong>Please note the following parties were deregistered in 2024</strong>:</p>
                  <br />
                  <p><strong>Atlantica Party Association of Nova Scotia</strong> - Effective April 30, 2024, the Atlantica Party Association of Nova Scotia voluntarily deregistered as a political party in Nova Scotia under Section 187 of the <a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em><u>Elections Act</u></em></a>.</p>
                  <br />
                  <p><strong>Nova Scotians United</strong> - Effective December 10, 2024, that Nova Scotians United was deregistered as a political party in Nova Scotia under Section 186 of the <a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em><u>Elections Act</u></em></a>. Nova Scotians United did not endorse any nominated candidates for the 42nd provincial general election held on November 26, 2024.</p>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default RegisteredPartiesInformation;
